import { c as _c } from "react/compiler-runtime";
/** Shown for any job that can take more than a second (FR-4). */
export function ProgressBar(t0) {
  const $ = _c(18);
  const {
    label,
    value,
    max
  } = t0;
  const known = value !== undefined && !!max;
  const t1 = known ? 0 : undefined;
  const t2 = known ? max : undefined;
  const t3 = known ? value : undefined;
  const t4 = known ? "h-full rounded-full bg-primary transition-[width]" : "h-full w-1/3 animate-pulse rounded-full bg-primary";
  let t5;
  if ($[0] !== known || $[1] !== max || $[2] !== value) {
    t5 = known ? {
      width: `${value / max * 100}%`
    } : undefined;
    $[0] = known;
    $[1] = max;
    $[2] = value;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t4 || $[5] !== t5) {
    t6 = <div className={t4} style={t5} />;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== label || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t6) {
    t7 = <div role="progressbar" aria-label={label} aria-valuemin={t1} aria-valuemax={t2} aria-valuenow={t3} className="h-2.5 overflow-hidden rounded-full bg-sand">{t6}</div>;
    $[7] = label;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== label) {
    t8 = <p className="text-sm text-ink" aria-live="polite">{label}</p>;
    $[13] = label;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7 || $[16] !== t8) {
    t9 = <div className="flex flex-col gap-1.5">{t7}{t8}</div>;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
}